import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api';

const OrderConfirmation = ({ deviceId }) => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkPaymentStatus();
  }, []);

  const checkPaymentStatus = async () => {
    try {
      const sessionId = searchParams.get('session_id');
      if (sessionId) {
        const result = await api.getStripeCheckoutStatus(sessionId);
        setStatus(result);
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#FEFEE3', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
        <img src="/logo.png" alt="Processing" style={{ width: '100px', height: '100px', imageRendering: 'pixelated', marginBottom: '20px' }} />
        <p style={{ color: '#4C956C', fontSize: '14px' }}>PROCESSING ORDER...</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#FEFEE3', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
      <div className="retro-card" style={{ background: '#FFF', padding: '60px 40px', maxWidth: '500px', textAlign: 'center' }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>✅</div>
        <h1 style={{ fontSize: '28px', color: '#2C6E49', marginBottom: '15px' }}>ORDER CONFIRMED!</h1>
        <p style={{ fontSize: '14px', color: '#4C956C', marginBottom: '30px' }}>
          Thank you for your purchase! A confirmation email has been sent.
        </p>
        
        {status && (
          <div style={{ background: '#F7F6D8', padding: '20px', marginBottom: '30px', border: '2px solid #000' }}>
            <p style={{ fontSize: '12px', color: '#4C956C', marginBottom: '5px' }}>ORDER NUMBER</p>
            <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#2C2C2C' }}>#{status.metadata?.order_id?.slice(-8) || 'N/A'}</p>
          </div>
        )}
        
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <Link to="/" className="retro-btn" style={{ background: '#2C6E49', color: '#FEFEE3', padding: '15px 30px', textDecoration: 'none', fontSize: '12px' }}>
            CONTINUE SHOPPING
          </Link>
          <Link to="/orders" className="retro-btn" style={{ background: '#FFF', color: '#2C2C2C', padding: '15px 30px', textDecoration: 'none', fontSize: '12px' }}>
            VIEW ORDERS
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
